import {Injectable} from "@angular/core";
import {HttpClient, HttpHandler} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
@Injectable()
export class PayJustNowApi extends HttpClient {
  private baseUrl = environment.production ? "/channel-virtual/api/v1" + '/pay-just-now' : environment.baseUrl + '/pay-just-now';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initialize(sessionToken : string) {
    const url = `${this.baseUrl}/initialize?sessionToken=${sessionToken}` ;
    return super.post(url, null);
  }

  public validate(sessionToken: string): Observable<any> {
    const url = `${this.baseUrl}/validate/${sessionToken}`;
    return super.get(url);
  }
}
